import { ru } from './ru';
import { en } from './en';

export const translations = { ru, en };
export type TranslationKeys = keyof typeof ru;